import { motion } from 'framer-motion';
import styled from 'styled-components/macro';
const SkillsList = styled(motion.div)`
	flex: 1;
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	align-items: flex-start;

	@media screen and (max-width: 900px) {
		margin-right: 0;
		justify-content: center;
		align-items: center;
	}
`;

export default SkillsList;
